// Chakra imports
import { Flex, Image, Text, useColorModeValue, Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

// Custom components
import { HSeparator } from 'components/separator/Separator';

export function SidebarBrand(props: { mini: boolean; hovered: boolean }) {
  const { mini, hovered } = props;
  const navigate = useNavigate();

  // Chakra color mode
  let logoColor = useColorModeValue('navy.700', 'white');
  let bgColor = useColorModeValue('white', 'navy.800');

  const handleLogoClick = () => {
    navigate('/assessment-v2');
  };

  return (
    <Flex alignItems="center" flexDirection="column" bg={bgColor} pt="20px">
      {/* Niko Logo - Full size when expanded */}
      <Box
        as="button"
        onClick={handleLogoClick}
        cursor="pointer"
        transition="opacity 0.2s"
        _hover={{ opacity: 0.8 }}
        display={
          mini === false
            ? 'block'
            : mini === true && hovered === true
            ? 'block'
            : 'none'
        }

        px="20px"
      >
        <Image
          src="/LOGO NIKO NEGRO.svg"
          alt="Niko Energy"
          w="100%"
          h="auto"
          maxW="220px"
          my="16px"
        />
      </Box>

      {/* Mini mode - Just "NIKO" text without the N */}
      <Flex
        as="button"
        onClick={handleLogoClick}
        cursor="pointer"
        display={
          mini === false
            ? 'none'
            : mini === true && hovered === true
            ? 'none'
            : 'flex'
        }
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        fontSize="10px"
        fontWeight="800"
        color={logoColor}
        my="16px"
        transition="opacity 0.2s"
        _hover={{ opacity: 0.8 }}
      >
        <Text lineHeight="1">IKO</Text>
      </Flex>

      <HSeparator mb="20px" />
    </Flex>
  );
}

export default SidebarBrand;
